var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg403Image(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 387,
    viewBox: "0 0 683 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.777 387H6.87654C1.61036 387 0 384.525 0 381.498C0 378.475 1.507 376 6.77319 376H675.568C680.833 376 683 378.475 683 381.498C683 384.525 681.041 387 675.777 387Z",
    fill: "#E6F2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448.393 382.315H508.61L487.052 273.857C486.082 268.985 482.555 265.555 478.505 265.555C474.456 265.555 470.92 268.985 469.959 273.857L448.401 382.315H448.393Z",
    fill: "#EB9175"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M439.075 382.755H517.941V374.942H439.075V382.755Z",
    fill: "#C7421B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.892 294.283H491.109L493.528 306.422H463.473L465.892 294.283Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M499.461 336.266H457.543L462.668 310.496H494.336L499.461 336.266Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M481.023 271.682H483.093L498.247 347.933H495.925L481.023 271.682Z",
    fill: "#DE4719"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M499.022 351.828L501.784 365.752H499.413L496.691 351.828H499.022Z",
    fill: "#DE4719"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.219 382.315H223.436L201.878 273.857C200.908 268.985 197.381 265.555 193.331 265.555C189.282 265.555 185.746 268.985 184.785 273.857L163.227 382.315H163.219Z",
    fill: "#EB9175"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.901 382.755H232.768V374.942H153.901V382.755Z",
    fill: "#C7421B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.71 294.283H205.935L208.346 306.422H178.299L180.71 294.283Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.279 336.266H172.369L177.494 310.496H209.163L214.279 336.266Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M195.85 271.682H197.919L213.073 347.933H210.751L195.85 271.682Z",
    fill: "#DE4719"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M213.848 351.828L216.61 365.752H214.231L211.51 351.828H213.848Z",
    fill: "#DE4719"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M275.13 188.261H257.475V382.763H275.13V188.261Z",
    fill: "#969696"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M275.324 197.942C280.679 192.957 280.979 184.574 275.994 179.219C271.009 173.864 262.626 173.564 257.271 178.549C251.915 183.534 251.615 191.917 256.601 197.272C261.586 202.627 269.968 202.927 275.324 197.942Z",
    fill: "#E7685B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M408.749 188.261H391.094V382.763H408.749V188.261Z",
    fill: "#969696"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M408.838 198.035C414.245 193.106 414.631 184.727 409.701 179.32C404.772 173.914 396.393 173.528 390.986 178.457C385.58 183.387 385.194 191.766 390.123 197.172C395.053 202.579 403.432 202.965 408.838 198.035Z",
    fill: "#E7685B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M339.959 175.014H326.264V223.539H339.959V175.014Z",
    fill: "#A7A9AC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M436.237 210.707H229.986V246.816H436.237V210.707Z",
    fill: "#BCB4D7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M246.664 246.816H230.279L247.462 210.707H263.846L246.664 246.816Z",
    fill: "#7D7ABE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M289.683 246.816H273.307L290.489 210.707H306.874L289.683 246.816Z",
    fill: "#7D7ABE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M332.709 246.816H316.324L333.515 210.707H349.891L332.709 246.816Z",
    fill: "#7D7ABE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M375.734 246.816H359.35L376.532 210.707H392.917L375.734 246.816Z",
    fill: "#7D7ABE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M418.761 246.816H402.377L419.56 210.707H435.944L418.761 246.816Z",
    fill: "#7D7ABE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M436.237 264.887H229.986V300.996H436.237V264.887Z",
    fill: "#BCB4D7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M246.664 301.005H230.279L247.462 264.887H263.846L246.664 301.005Z",
    fill: "#7D7ABE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M289.683 301.005H273.307L290.489 264.887H306.874L289.683 301.005Z",
    fill: "#7D7ABE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M332.709 301.005H316.324L333.515 264.887H349.891L332.709 301.005Z",
    fill: "#7D7ABE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M375.734 301.005H359.35L376.532 264.887H392.917L375.734 301.005Z",
    fill: "#7D7ABE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M418.761 301.005H402.377L419.56 264.887H435.944L418.761 301.005Z",
    fill: "#7D7ABE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M342.368 189.942C359.062 184.832 368.453 167.156 363.342 150.462C358.232 133.768 340.556 124.377 323.862 129.487C307.168 134.597 297.777 152.273 302.888 168.967C307.998 185.662 325.674 195.052 342.368 189.942Z",
    fill: "#E44343"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M352.377 154.776H313.848V164.666H352.377V154.776Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M274.659 188.261C274.659 183.65 270.919 179.91 266.308 179.91C261.697 179.91 257.957 183.65 257.957 188.261C257.957 192.873 261.697 196.612 266.308 196.612C270.919 196.612 274.659 192.873 274.659 188.261Z",
    fill: "#EE8C70"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M408.274 188.261C408.274 183.65 404.535 179.91 399.923 179.91C395.312 179.91 391.572 183.65 391.572 188.261C391.572 192.873 395.312 196.612 399.923 196.612C404.535 196.612 408.274 192.873 408.274 188.261Z",
    fill: "#EE8C70"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M267.43 316.273H266.803V382.755H267.43V316.273Z",
    fill: "#6D6E71"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M261.069 329.602H260.441V382.755H261.069V329.602Z",
    fill: "#6D6E71"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M405.268 329.602H404.641V382.755H405.268V329.602Z",
    fill: "#6D6E71"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M265.161 344.601H264.533V382.755H265.161V344.601Z",
    fill: "#6D6E71"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M396.795 344.601H396.168V382.755H396.795V344.601Z",
    fill: "#6D6E71"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.275 375.151L421.77 367.142C422.88 366.75 424.226 367.207 424.448 368.051L427.97 381.495C428.175 382.28 427.303 383 426.144 383H402.051C395.721 383 393.652 377.151 399.275 375.151Z",
    fill: "#1E3056"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.054 187H424.459C424.431 187.314 424.417 187.615 424.362 187.94C420.205 213.052 418.083 249.933 418.998 285.625C419.652 311.296 421.878 336.357 426.062 355.974C431.838 383.06 409.152 380.239 406.919 368.336C401.712 340.571 397.652 312.177 394.648 285.625C390.21 246.387 388.083 211.166 388 187.94C388 187.615 388.035 187.314 388.054 187Z",
    fill: "#003D61"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.378 375.151L469.577 367.144C470.72 366.749 472.107 367.206 472.337 368.05L475.969 381.498C476.182 382.28 475.28 383 474.088 383H449.242C442.712 383 440.579 377.153 446.378 375.151Z",
    fill: "#1E3056"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.05 187H469.592C469.563 187.314 469.551 187.615 469.5 187.94C465.553 213.052 463.54 249.933 464.408 285.624C465.031 311.297 467.141 336.356 471.11 355.974C476.59 383.062 455.066 380.238 452.947 368.336C448.008 340.572 444.155 312.176 441.305 285.624C437.094 246.387 435.076 211.166 435 187.94C434.998 187.615 435.032 187.314 435.05 187Z",
    fill: "#003D61"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.261 161.297C390.478 159.202 390.654 157.1 390.774 154.994C391.805 140.013 391.277 125.092 387 110.36C387.785 101.393 388.903 92.5721 390.525 84.0936C393.216 70.0378 407.227 63.3478 423.938 60.6087C440.079 57.962 458.72 59.0072 472.16 60.7011C475.782 61.1561 479.048 61.6584 481.759 62.1472C488.39 63.35 495.565 65.3751 499.327 70.9501C503.609 77.2932 501.905 85.7537 500.009 93.1645C490.692 129.619 480.707 165.908 470.063 202C445.873 201.439 421.681 200.876 397.486 200.315C395.062 200.259 392.403 200.112 390.613 198.479C388.824 196.844 388.449 194.215 388.205 191.807C387.943 189.235 387.731 186.593 387.503 183.968C388.544 176.411 389.548 168.852 390.261 161.297Z",
    fill: "#EDEDED"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.225 74.2593C442.701 69.388 445.296 64.5689 448 59.8041C443.509 56.8705 437.685 54.8806 432.556 56.693C428.615 58.0857 422.968 62.2846 425.737 66.1662C426.486 67.2165 431.592 71.6869 434.961 75.0548C436.513 76.6083 439.248 76.1802 440.225 74.2593Z",
    fill: "#FFB288"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.966 7.22009L416.151 15.0834C414.939 26.7949 421.151 37.0823 429.958 37.9422C438.763 38.8043 446.96 29.9231 448.171 18.2116L448.988 10.3483C448.993 10.2873 448.993 10.2309 449 10.1722C440.337 3.78045 429.677 1.27294 418.737 0C417.86 2.22539 417.233 4.64487 416.966 7.22009Z",
    fill: "#693523"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.918 22.6172C442.661 14.7148 438.262 7.70702 432.142 7.04792C429.553 6.76933 427.08 7.72288 425 9.4533L441.882 23L441.918 22.6172Z",
    fill: "#693523"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.224 9C420.078 11.3631 417.771 15.2161 417.297 19.779L416.091 31.3608C415.265 39.2755 420.157 46.2877 426.964 46.9499C433.766 47.6098 440.008 41.6749 440.834 33.7624L442 22.5616L423.224 9Z",
    fill: "#FFB288"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.127 61.9883L429.052 61.0706C427.804 60.9478 426.885 59.8168 427.012 58.5652L429.365 35.0604C429.491 33.8066 430.614 32.8846 431.861 33.0117L440.938 33.9273C442.185 34.0522 443.113 33.2788 442.989 34.5326L440.623 59.9396C440.497 61.1912 439.374 62.1154 438.127 61.9883Z",
    fill: "#FFB288"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.315 115C487.906 105.222 480.82 98.3725 473.933 90.7215C461.46 76.859 481.536 55.591 494.118 69.5717C501.508 77.7792 509.477 85.5135 517.141 93.48C517.415 93.7648 517.717 94.0562 518 94.3432C513.013 102.557 505.822 109.562 497.315 115Z",
    fill: "#EDEDED"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.132 109.904C397.302 102.663 405.601 97.7004 413.885 91.9303C428.89 81.4741 414.289 56.7799 399.153 67.3245C390.265 73.5142 380.924 79.125 371.826 85.0245C371.5 85.2354 371.147 85.4465 370.812 85.6574C373.797 94.5843 379.161 102.845 386.132 109.904Z",
    fill: "#EDEDED"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.701 94C525.16 100.672 533.84 108.019 537.573 116.444C542.74 128.105 499.484 166.776 489.971 175.006C475.619 187.426 471.019 174.602 482.375 159.24C490.353 148.448 496.787 134.79 504.983 122.79C502.45 120.026 500.12 117.54 497.881 115.171C506.443 109.595 513.681 102.419 518.701 94Z",
    fill: "#FFB288"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.061 84.7016C363.48 89.6382 353.647 94.7335 348.266 101.932C340.82 111.895 373.355 158.097 380.571 167.997C391.455 182.936 398.62 171.743 391.217 154.66C386.017 142.658 382.906 128.268 377.764 115.07C380.769 112.993 383.521 111.137 386.161 109.372C379.266 102.204 373.976 93.8013 371.061 84.7016Z",
    fill: "#FFB288"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.781 167.313C469.666 169.214 469.368 171.428 469.193 173.583C468.971 176.305 468.961 179.032 469.06 181.757C469.088 181.799 469.127 181.835 469.158 181.88C469.698 182.634 470.316 183.31 470.891 184.04C471.039 184.192 471.135 184.291 471.219 184.378C471.432 184.559 471.64 184.747 471.862 184.922C472.124 185.128 473.371 185.882 473.619 186.093C474.548 186.422 475.711 186.798 473.844 186.382C474.326 186.487 474.777 186.643 475.229 186.793C475.224 186.702 475.219 186.608 475.217 186.514C475.409 186.605 475.577 186.735 475.785 186.8C478.003 187.499 480.544 186.283 481.922 184.445C483.3 182.609 483.732 180.301 483.915 178.07C484.301 173.393 483.459 168.146 479.601 165.307C478.64 164.602 477.498 164.074 476.281 164.006C474.017 163.888 471.9 165.415 470.781 167.313Z",
    fill: "#FFB288"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.105 164.978C400.746 167.06 400.537 169.265 400.225 171.387C399.831 174.067 399.234 176.705 398.535 179.317C398.499 179.352 398.453 179.378 398.414 179.414C397.731 180.025 396.992 180.543 396.282 181.122C396.108 181.237 395.994 181.311 395.895 181.377C395.652 181.506 395.411 181.642 395.161 181.762C394.865 181.904 393.51 182.36 393.226 182.509C392.268 182.624 391.077 182.732 392.948 182.739C392.466 182.735 392.001 182.788 391.537 182.834C391.562 182.746 391.587 182.656 391.611 182.566C391.407 182.612 391.218 182.701 391.005 182.718C388.737 182.907 386.586 181.176 385.682 179.097C384.777 177.021 384.878 174.695 385.2 172.497C385.872 167.892 387.841 163.005 392.148 161.106C393.221 160.635 394.426 160.375 395.6 160.577C397.784 160.958 399.462 162.898 400.105 164.978Z",
    fill: "#FFB288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403Image);
export default __webpack_public_path__ + "static/media/403_Image.8f04bdd6b222e9b75fe8d3c2927c8711.svg";
export { ForwardRef as ReactComponent };